var exports = {
  "kL": "GroupedVoiceParticipant.module__container___alJzdG",
  "AG": "GroupedVoiceParticipant.module__participantButton___alJzdG",
  "IT": "GroupedVoiceParticipant.module__participantButtonSpeaking___alJzdG",
  "O": "GroupedVoiceParticipant.module__participantButtonContextMenuActive___alJzdG",
  "SX": "GroupedVoiceParticipant.module__avatarAndName___alJzdG",
  "VW": "GroupedVoiceParticipant.module__nameContainer___alJzdG",
  "F8": "GroupedVoiceParticipant.module__participantName___alJzdG",
  "xr": "GroupedVoiceParticipant.module__participantNameSpeaking___alJzdG",
  "S$": "GroupedVoiceParticipant.module__participantNameCurrent___alJzdG",
  "u$": "GroupedVoiceParticipant.module__deviceCountButton___alJzdG",
  "g0": "GroupedVoiceParticipant.module__iconsAndToggle___alJzdG",
  "pP": "GroupedVoiceParticipant.module__devicesContainer___alJzdG",
  "nt": "GroupedVoiceParticipant.module__flexShrinkZero___alJzdG",
};

module.exports = exports;
